import type { IconSvgObject } from './types';

const UserDollarIcon: IconSvgObject = [
  ["path", { d: "M12.495 13.5663L11.5 13.5C11.1446 13.5097 10.8134 13.5226 10.5008 13.5379C6.8 13.7193 3.78417 16.8058 3.5 20.5002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "11.5", cy: "6.5", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.5 14H18M15.5 20H18M18 12.5V14M18 14H17C16.1716 14 15.5 14.6716 15.5 15.5C15.5 16.3284 16.1716 17 17 17H19C19.8284 17 20.5 17.6716 20.5 18.5C20.5 19.3284 19.8284 20 19 20H18M18 21.5V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserDollarIcon;
